import React from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";
import Quickcontact from "../components/Quickcontact";

const apiUrl = process.env.REACT_APP_API_URL;

function OverviewTemplate({ page }) {
  return (
    <>
      <Head />
      {/* Start Breadcrumbs */}
      <section className="ak-about-hero-1">
        <img
          src={page.hero_image ? `${apiUrl}/${page.hero_image}` : "/assets/img/bg/about-bg.png"}
          className="about-hero-bg ak-bg object-cover"
          alt="..."
          data-swiper-parallax={1152}
        />
        <div className="container">
          <div className="about-hero-content">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
              {page.subtitle && (
                <p className="ak-section-subtitle animation-title" style={{ color: "#fff" }}>
                  {page.subtitle}
                </p>
              )}
              <h2 className="ak-section-title animation-title" style={{ color: "white" }}>
                {page.title}
              </h2>
            </div>
            <a href="/" className="back-btn" style={{ color: "white !important" }}>
              Home / About / {page.title}
            </a>
          </div>
        </div>
      </section>
      {/* End Breadcrumbs */}
      {/* Start About */}
      <div className="ak-height-125 ak-height-lg-80" />
      <section>
        <div className="about-us-content-bg">
          <div className="container">
            <div className="about-us-content">
              <div className="image-content">
                {page.cover_image && (
                  <img className="about-img-1" src={`${apiUrl}/${page.cover_image}`} alt="..." />
                )}
                {page.secondary_image && (
                  <img className="about-img-2" src={`${apiUrl}/${page.secondary_image}`} alt="..." />
                )}
              </div>
              <div className="info-content">
                <div className="ak-section-heading ak-style-1 animation-title-content animation-style3">
                  {page.subtitle && <p className="ak-section-subtitle animation-title">{page.subtitle}</p>}
                  {page.heading && <h2 className="ak-section-title animation-title">{page.heading}</h2>}
                  <div className="ak-section-desp" dangerouslySetInnerHTML={{ __html: page.body || "" }} />
                </div>
              </div>
            </div>
            <div className="ak-height-125 ak-height-lg-80" />
          </div>
          <img className="aboutus" src="/assets/img/bg/aboutus.png" alt="..." />
        </div>
      </section>
      {/* End About */}
      {/* Start Feature */}
      <div className="ak-height-100 ak-height-lg-80" />
      <section className="container">
        <div className="feature-content">
          <div className="feature-card">
            <img className="feature-icon" src="/assets/img/icon/light.svg" alt="..." />
            <div className="feature-body">
              <h5 className="feature-title">
                CPD UK <br />
                Accredited Academy
              </h5>
            </div>
          </div>
          <div className="ak-feature-hr" />
          <div className="feature-card">
            <img className="feature-icon" src="/assets/img/icon/hand.svg" alt="..." />
            <div className="feature-body">
              <h5 className="feature-title">
                IWFM UK <br />
                Accredited Academy
              </h5>
            </div>
          </div>
          <div className="ak-feature-hr" />
          <div className="feature-card">
            <img className="feature-icon" src="/assets/img/icon/note.svg" alt="..." />
            <div className="feature-body">
              <h5 className="feature-title">
                International Award <br />
                winning Academy
              </h5>
            </div>
          </div>
        </div>
      </section>
      {/* End Feature */}
      {/* Start Atd skills */}
      <div className="service-bg" style={{ backgroundColor: "beige" }}>
        <div className="container">
          <div className="ak-height-65 ak-height-lg-50" />
          <div className="ak-slider ak-slider-client-logo">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <img src="/assets/img/clientLogo/log_1.png" alt="..." />
              </div>
              <div className="swiper-slide">
                <img src="/assets/img/clientLogo/log_2.png" alt="..." />
              </div>
              <div className="swiper-slide">
                <img src="/assets/img/clientLogo/log_3.png" alt="..." />
              </div>
              <div className="swiper-slide">
                <img src="/assets/img/clientLogo/log_4.png" alt="..." />
              </div>
              <div className="swiper-slide">
                <img src="/assets/img/clientLogo/log_1.png" alt="..." />
              </div>
              <div className="swiper-slide">
                <img src="/assets/img/clientLogo/log_2.png" alt="..." />
              </div>
            </div>
          </div>
          <div className="ak-height-65 ak-height-lg-50" />
        </div>
      </div>
      {/* End Atd skills */}
      {/* Start services short info */}
      <div className="ak-height-125 ak-height-lg-80" />
      <section className="container">
        <div className="ak-slider strategic-slider">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <div className="strategic single-card">
                <div className="strategic-info">
                  <div className="ak-section-heading ak-style-1">
                    <p className="ak-section-subtitle">Vision &amp; Mission</p>
                    <h2 className="ak-section-title">Our Vision</h2>
                  </div>
                  <div className="ak-height-50 ak-height-lg-30" />
                  <div className="personalized-long-term">
                    <div className="personalized">
                      <h5 className="title">
                        Educating for Impact. Leading with Purpose. Sustaining the Industry.
                      </h5>
                      <p className="desp">
                        To be a global leader in Facilities &amp; Professional Management
                        education, transforming aspiring individuals into skilled,
                        confident, and world-class professionals. We aim to empower career
                        growth, deliver excellence in training, and shape a sustainable
                        future for the FM industry.
                      </p>
                    </div>
                  </div>
                  <div className="ak-height-50 ak-height-lg-30" />
                </div>
                <div className="strategic-img">
                  <img src="/assets/img/strategic/sticky-x.png" alt="..." data-swiper-parallax={-200} />
                </div>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="strategic single-card">
                <div className="strategic-info">
                  <div className="ak-section-heading ak-style-1">
                    <p className="ak-section-subtitle">Vision &amp; Mission</p>
                    <h2 className="ak-section-title">Our Mission</h2>
                  </div>
                  <div className="ak-height-50 ak-height-lg-30" />
                  <div className="personalized-long-term">
                    <div className="personalized">
                      <h5 className="title">
                        Empowering Future-Ready Professionals Through World-Class FM
                        Education
                      </h5>
                      <p className="desp">
                        To empower aspiring professionals with world-class Facilities &amp;
                        Professional Management education by providing global
                        certifications, practical training, and leadership development,
                        bridging career gaps and preparing a skilled, future-ready
                        workforce.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="ak-height-50 ak-height-lg-30" />
                </div>
                <div className="strategic-img">
                  <img src="/assets/img/strategic/sticky-y.png" alt="..." data-swiper-parallax={-200} />
                </div>
              </div>
            </div>
            <div className="swiper-slide">
              <div className="strategic single-card">
                <div className="strategic-info">
                  <div className="ak-section-heading ak-style-1">
                    <p className="ak-section-subtitle">Values</p>
                    <h2 className="ak-section-title">Our Core Values</h2>
                  </div>
                  <div className="ak-height-50 ak-height-lg-30" />
                  <div className="personalized-long-term">
                    <div className="personalized">
                      <h5 className="title">
                        Driven by Excellence, Inspired by Innovation, Grounded in
                        Integrity, and Committed to Empowerment.
                      </h5>
                      <p className="desp"></p>
                      <ul>
                        <li>
                          Excellence - Striving for the highest standards in education,
                          training, and professional development.
                        </li>
                        <li>
                          Innovation - Encouraging creative thinking, problem-solving, and
                          modern approaches to learning and growth.
                        </li>
                        <li>
                          Integrity - Upholding honesty, transparency, and ethical
                          practices in all programs.
                        </li>
                        <li>
                          Empowerment - Equipping students and professionals with the
                          skills and confidence to succeed.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="ak-height-50 ak-height-lg-30" />
                </div>
                <div className="strategic-img">
                  <img src="/assets/img/strategic/sticky-z.png" alt="..." data-swiper-parallax={-200} />
                </div>
              </div>
            </div>
          </div>
          <div className="strategic-swiper-controller">
            <button className="strategic-next-btn slider-btn next">
              <svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
                  stroke="#030917"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button className="strategic-prev-btn slider-btn prev">
              <svg width={10} height={18} viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
                  stroke="#030917"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <div className="strategic-slider-pagination">
              <span className="strategic-current-slide">0</span> /
              <span className="strategic-total-slides">0</span>
            </div>
          </div>
        </div>
      </section>
      {/* End services short info */}
      <Quickcontact />
      <Foot />
    </>
  );
}

export default OverviewTemplate;
